import module from 'empresas/module.js'
import template from './template.html'

export class EmpresasAgregarComponent {
  aceptar = false
  regimenFiscal = {}
  regimenCopia = {}
  seleccionar = false
  data = {
    razon_social: null,
    rfc: null,
    regimen_fiscal_id: undefined,
    empresa_interna: false,
    img: null,
  }

  constructor ($q, EmpresasCatalogoRegimenFiscal, EmpresasRfcExiste) {
    this.EmpresaCatalogoRegimenFiscalService = EmpresasCatalogoRegimenFiscal
    this.EmpresasRfcExisteService = EmpresasRfcExiste
    this.existeRFC = {
      existe: (rfc) => {
        return $q((resolve, reject) => {
          this.EmpresasRfcExisteService.get(rfc)
            .then((response) => {
              if (response.data.existe) {
                reject()
              } else {
                resolve()
              }
            })
        })
      },
    }
  }

  $onInit () {
    this.promise = this.EmpresaCatalogoRegimenFiscalService.get()
      .then((response) => (this.regimenFiscal = response.data, this.regimenCopia = this.regimenFiscal))
  }

  filtarRegimen (rfc) {
    this.data.regimen_fiscal_id = undefined
    this.regimenFiscal = rfc.length === 12 ? this.regimenCopia.filter(item => item.moral) : this.regimenCopia.filter(item => item.fisica)
  }

  obtenerImg (data) {
    this.seleccionar = false
    if (!data.exito) return

    this.data.img = data.img
  }
}

module.component('empresasAgregar', {
  controller: EmpresasAgregarComponent,
  template: template,
})



// WEBPACK FOOTER //
// ./src/empresas/components/agregar/component.js